import { useLanguage } from '../../context/LanguageContext';

// Firm names are plain text, not logos: they are benchmark/validation sources
// (see /scripts/validation/) used to check our calculations against published
// sustainability reports. They are NOT customers, partners or endorsers of
// Sustainalyze — the disclaimer below must always render alongside them.
const VALIDATION_FIRMS = ['BASF', 'BMW', 'Unilever', 'Holcim', 'Arçelik'];

export default function ValidationBand() {
  const { t } = useLanguage();

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="rounded-3xl border border-slate-200/60 bg-white/70 backdrop-blur-sm p-8 text-center">
        <h3 className="text-2xl font-bold text-slate-900 mb-3">{t('landing.validation.title')}</h3>
        <p className="text-slate-600 max-w-2xl mx-auto leading-relaxed mb-6">
          {t('landing.validation.body')}
        </p>

        <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 mb-6 list-none">
          {VALIDATION_FIRMS.map((firm) => (
            <li key={firm} className="text-sm font-semibold tracking-wide text-slate-500">
              {firm}
            </li>
          ))}
        </ul>

        <p className="text-xs text-slate-400 max-w-2xl mx-auto leading-relaxed">
          {t('landing.validation.disclaimer')}
        </p>
      </div>
    </div>
  );
}
